import Vue from 'vue';
import VueTippy from 'vue-tippy';

export default {
    init() {
        Vue.use(VueTippy, {
            arrow: true,
            arrowType: 'round',
            animateFill: false,
            animation: 'shift-away',
            duration: 250,
            position: 'left',
        });
    },
};
